import React from 'react';
import '../../styles/customPagination.css';

const CustomPagination = ({ totalSlides, activeIndex, onBulletClick }) => {
    const VISIBLE_BULLETS = 7;
    const CENTER_POSITION = 3;
    const EDGE_SLIDES = 3;

    // Calcola quali pallini mostrare
    const calculateVisibleBullets = () => {
        if (totalSlides <= VISIBLE_BULLETS) {
            // Caso semplice: mostra tutti i pallini disponibili
            return {
                startIndex: 0,
                endIndex: totalSlides,
                activeBulletPosition: activeIndex
            };
        }

        // Determina se siamo all'inizio, al centro o alla fine
        const isAtStart = activeIndex < EDGE_SLIDES;
        const isAtEnd = activeIndex >= (totalSlides - EDGE_SLIDES);

        let startIndex, endIndex, activeBulletPosition;

        if (isAtStart) {
            // INIZIO: mostra i primi 7, lineetta si muove da sinistra verso il centro
            startIndex = 0;
            endIndex = VISIBLE_BULLETS;
            activeBulletPosition = activeIndex;
        } else if (isAtEnd) {
            // FINE: mostra gli ultimi 7, lineetta si muove dal centro verso destra
            startIndex = totalSlides - VISIBLE_BULLETS;
            endIndex = totalSlides;
            activeBulletPosition = activeIndex - startIndex;
        } else {
            // CENTRO: lineetta fissa al centro, pallini scorrono
            startIndex = activeIndex - CENTER_POSITION;
            endIndex = activeIndex + CENTER_POSITION + 1;
            activeBulletPosition = CENTER_POSITION;
        }

        return { startIndex, endIndex, activeBulletPosition };
    };

    const { startIndex, endIndex, activeBulletPosition } = calculateVisibleBullets();

    // Genera array di indici visibili
    const visibleIndices = [];
    for (let i = startIndex; i < endIndex; i++) {
        visibleIndices.push(i);
    }

    return (
        <div className="custom-pagination">
            {visibleIndices.map((slideIndex, bulletIndex) => (
                <span
                    key={slideIndex}
                    className={`custom-pagination-bullet ${bulletIndex === activeBulletPosition ? 'active' : ''}`}
                    onClick={() => onBulletClick && onBulletClick(slideIndex)}
                    role="button"
                    tabIndex={0}
                    aria-label={`Go to slide ${slideIndex + 1}`}
                />
            ))}
        </div>
    );
};

export default CustomPagination;

























